import { AbstractTicketSymbolProperties } from "@lib/titan2-slingo/dist/game/view/abstract/properties/AbstractTicketSymbolProperties";
import { SlingoStyle } from "@lib/titan2-slingo/dist/game/view/abstract/style/SlingoStyle";
import { ButtonProperties } from "@lib/titan2/dist/game/control/properties/ButtonProperties";
import { SpineProperties } from "@lib/titan2/dist/game/control/properties/SpineProperties";
/**
 * GameTicketSymbolProperties.ts
 */
export class GameTicketSymbolProperties extends AbstractTicketSymbolProperties {
    constructor() {
        super();
        this.setDefaultValues();
    }
    setDefaultValues() {
        this.spineProperties = new SpineProperties(SlingoStyle.TICKET_SYMBOL, SlingoStyle.MODULE);
        this.buttonProperties = new ButtonProperties(SlingoStyle.TICKET_SYMBOL_BUTTON, SlingoStyle.MODULE);
        this.hideButton = false;
        // this.scale.set(0.99, 0.99);
    }
}
//# sourceMappingURL=GameTicketSymbolProperties.js.map